
      if (!window.__WFM_IS_PUBLIC_QR__) {
        import('/src/main.ts')
      }
    